module.exports = __webpack_public_path__ + "img/arrow.fdbe2d7a.png";